import { FC } from 'react'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'

const ErrorAuthResetPassword: FC = () => {
  return (
    <>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Ein Fehler ist aufgetreten</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fw-semibold fs-6 text-gray-700 mb-7'>Bitte versuchen Sie es erneut. <br />Sollte das Problem weiterhin bestehen, finden Sie in der <a href='https://partner.ofindo.de/hilfe/' target='_blank' rel="noreferrer">Hilfe</a> Unterstützung.</div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-2'>
        <img
          src={toAbsoluteUrl('/media/auth/membership.png')}
          className='mw-100 mh-250px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/auth/membership-dark.png')}
          className='mw-100 mh-250px theme-dark-show'
          alt=''
        />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      <div className='mb-0'>
        <Link to='/auth/forgot-password' className='btn btn-sm btn-primary'>
          Passwort vergessen
        </Link>
      </div>
      {/* end::Link */}
    </>
  )
}

export { ErrorAuthResetPassword }
